import { supported } from '@mapbox/mapbox-gl-supported';
//biome-ignore lint/style/noRestrictedImports: allow here
import type mapboxgl from 'mapbox-gl';
import { useEffect, useState } from 'react';
import { appendScript } from '../helpers/append-script';
import { appendStylesheet } from '../helpers/append-stylesheet';

/**
 * https://docs.mapbox.com/mapbox-gl-js/guides/install/
 */
export const useMapbox = () => {
  const [state, setState] = useState<{
    error: boolean;
    loading: boolean;
    mapbox?: typeof mapboxgl;
    supported: boolean;
  }>({
    error: false,
    loading: true,
    supported: true,
  });

  useEffect(() => {
    const s = supported();
    if (!s) {
      setState(prev =>
        Object.assign({}, prev, {
          loading: false,
          supported: s,
        })
      );
      return;
    }
    // use the script if it is already there
    if (window.mapboxgl) {
      setState(prev =>
        Object.assign({}, prev, {
          loading: false,
          supported: s,
          mapbox: window.mapboxgl,
        })
      );
      return;
    }

    appendStylesheet(
      'https://api.mapbox.com/mapbox-gl-js/v3.15.0/mapbox-gl.css'
    );

    appendScript(
      'https://api.mapbox.com/mapbox-gl-js/v3.15.0/mapbox-gl.js',
      () =>
        setState(prev =>
          Object.assign({}, prev, {
            loading: false,
            mapbox: window.mapboxgl,
          })
        ),
      {
        onError: () =>
          setState(prev =>
            Object.assign({}, prev, {
              loading: false,
              error: true,
            })
          ),
      }
    );
  }, []);

  return state;
};
